import React, { FC } from 'react'
import en from 'src/constants/en'
import Button from 'src/components/Button'
import { CampaignPayloadKeyword } from 'src/services/__generated__/api'
import { Card } from 'src/components/Card'
import styles from './addNewKeywordModalContent.module.scss'

export interface AddNewKeywordModalContentProps {
  addNewKeyword: () => void
  addedKeywordsArr?: string[]
  closeAndClear: () => void
  currentKeywordInput: string
  handleChangeKeywordSentimentsValue: (
    keywordData: CampaignPayloadKeyword
  ) => void
  handleDeleteKeyword?: (keyword: string) => void
  handleFinalizeKeywordForm: () => void
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onGoBack?: () => void
  setCurrentKeywordInput: (value: string) => void
}

export const AddNewKeywordModalContent: FC<AddNewKeywordModalContentProps> = ({
  addedKeywordsArr,
  setCurrentKeywordInput,
  handleKeyDown,
  currentKeywordInput,
  addNewKeyword,
  closeAndClear,
  handleFinalizeKeywordForm,
  handleDeleteKeyword,
  onGoBack,
}) => {
  const hasKeywordInput = currentKeywordInput.trim().length > 0
  const hasAddedKeywords = !!addedKeywordsArr?.length

  return (
    <Card className={styles.addNewKeywordModalContent}>
      <div className={styles.modalHeader}>
        <button
          aria-label="Go back"
          className={styles.backButton}
          onClick={onGoBack}
          type="button"
        >
          ‹
        </button>
        <span>{en.addNewKeyword}</span>
        <button
          aria-label="Close"
          className={styles.closeButton}
          onClick={closeAndClear}
          type="button"
        >
          ×
        </button>
      </div>

      <div className={styles.modalBody}>
        <div className={styles.label}>{en.keyword}</div>

        <div className={styles.inputContainer}>
          <input
            className={styles.input}
            onChange={(e) => setCurrentKeywordInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={en.enterAKeyword}
            type="text"
            value={currentKeywordInput}
          />
          <Button
            isDisabled={!hasKeywordInput}
            onClick={addNewKeyword}
            type="button"
          >
            {en.add}
          </Button>
        </div>

        {hasAddedKeywords && (
          <div className={styles.keywordTags}>
            {addedKeywordsArr?.map((keyword) => (
              <div className={styles.keywordTag} key={keyword}>
                <span>{keyword}</span>
                <button
                  aria-label={`Remove ${keyword}`}
                  className={styles.keywordTagRemove}
                  onClick={() => handleDeleteKeyword?.(keyword)}
                  type="button"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.modalFooter}>
        <button className={styles.cancel} onClick={closeAndClear} type="button">
          {en.cancel}
        </button>

        <Button
          isDisabled={!hasAddedKeywords}
          onClick={handleFinalizeKeywordForm}
          type="button"
        >
          {en.create}
        </Button>
      </div>
    </Card>
  )
}
